import { CurrentUser } from "models/auth/CurrentUser";
import { CurrentUserData } from "models/auth/types";
import { BaseServices } from "./baseServices";

export class CurrentUserService extends BaseServices<
	CurrentUserData,
	CurrentUser
> {
	constructor() {
		super(CurrentUser);
	}

	async getCurrentUser(): Promise<any> {
		return super.retrieve("users/me");
	}

	static getInstance() {
		return new CurrentUserService();
	}
}
